import LandingPage from "./landing/LandingPage";

function Pageview() {
  return <LandingPage />;
}

export default Pageview;
